import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "../mock/mock";

const Media = () => {
  return (
    <main>
      <section className="relative bg-black text-white pt-40 pb-20 md:pt-48 md:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="text-[11px] uppercase tracking-[0.32em] text-white/60 mb-6">Media</p>
          <h1 className="font-display text-[14vw] md:text-[8vw] uppercase leading-[0.92]">
            Every <span className="font-serif-display italic font-black">surface.</span> <br />
            Every commute.
          </h1>
          <p className="mt-8 max-w-2xl text-white/75 text-lg leading-relaxed">
            Explore the full AMS media portfolio — from iconic urban hoardings to
            programmatic DOOH networks across India's top markets.
          </p>
        </div>
      </section>

      <section className="bg-white text-black">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
            {SERVICES.map((s, i) => (
              <a
                key={s.title}
                href="#"
                className="group block"
              >
                <div className="relative aspect-[16/10] w-full overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover grayscale group-hover:scale-105 group-hover:grayscale-0 transition-all duration-[1000ms] ease-out"
                  />
                  <div className="absolute top-4 left-4 text-[11px] uppercase tracking-[0.24em] text-white bg-black/40 px-3 py-1 backdrop-blur">
                    0{i + 1}
                  </div>
                </div>
                <div className="mt-6 flex items-start justify-between gap-6">
                  <div>
                    <h3 className="font-display text-4xl md:text-5xl uppercase leading-none">
                      {s.title}
                    </h3>
                    <p className="mt-4 text-black/70 leading-relaxed max-w-md">
                      {s.blurb}
                    </p>
                  </div>
                  <ArrowUpRight className="w-6 h-6 mt-2 group-hover:rotate-45 transition-transform duration-300" />
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-black text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <h3 className="font-display text-[10vw] md:text-[5.6vw] uppercase leading-[0.92]">
            Plan your <span className="font-serif-display italic font-black">media.</span>
          </h3>
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 text-sm uppercase tracking-[0.22em] font-semibold px-7 py-4 border border-white hover:bg-white hover:text-black transition-colors duration-200"
          >
            Request Inventory <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Media;
